import { QueryCache, QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

// interface ServerResponse {
//   message: string;
//   method: string;
//   params: { [key: string]: unknown };
//   stack: string;
//   status: number;
//   success: boolean;
//   url: string;
// }

const onError = (e: unknown) => {
  // const mode = process.env.MODE;
  const error = e as AxiosError;

  const ACCESS_DENIED = 403;

  const BAD_REQUEST_STATUS_CODE = 400;
  // TODO: handle payment required
  // const PAYMENT_REQUIRED = 402;

  const NOT_FOUND = 404;
  // const INTERNAL_SERVER_ERROR = 500;

  if (!error?.response) return;

  // const data = error.response.data as ServerResponse;

  if (
    [BAD_REQUEST_STATUS_CODE, ACCESS_DENIED].includes(error.response.status)
  ) {
    // const requestError = "Something went wrong!";
    // showToast({
    //   name: "bad-request",
    //   type: "destructive",
    //   position: "top",
    //   text:
    //     mode === "development" ? data?.message ?? requestError : requestError,
    // });
  }

  if (error.response.status === NOT_FOUND) {
    // showToast({
    //   name: "not-found",
    //   type: "destructive",
    //   position: "top",
    //   text: data?.message ?? "Data not found!",
    // });
  }

  // Error states are now handled inline in components, not via redirects
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 3,
    },
  },
  queryCache: new QueryCache({
    onError,
  }),
});
